export enum EDialogEvents {
    INIT = 'dialog:initialize',
    CLEANUP = 'dialog:cleanup',
    OPEN_DIALOG = 'dialog:open',
    CLOSE_DIALOG = 'dialog:close',
    DIALOG_CLOSED = 'dialog:closed',
}
